var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.005,
    height: 61.122,
    viewBox: "0 0 173.005 61.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1",
    transform: "translate(0.295 61.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1",
    "data-name": "\\u30D1\\u30B9 1",
    d: "M74.779-.91h-.886V-1.8h-5.34V-.91h-.886V-4.8c-.886.3-1.476.886-2.386,1.206l-.886-.615c1.8-.886,3.272-1.5,4.749-2.387a9.15,9.15,0,0,0-2.067-1.5,6.333,6.333,0,0,0-1.5.911L64.69-7.8a11.58,11.58,0,0,0,4.454-3.888l.886.3c-.3.3-.3.591-.591.911H73.6v.59A16.291,16.291,0,0,1,69.439-6h5.34ZM67.667-8.686a11.205,11.205,0,0,1,2.067,1.5,11.508,11.508,0,0,0,2.682-2.707H68.848C68.258-9.3,67.963-9.006,67.667-8.686Zm6.226,6.275V-5.094h-5.34v2.682Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2",
    "data-name": "\\u30D1\\u30B9 2",
    d: "M86.073-.91h-.911V-1.8H78.346V-.91h-.885V-6.3h3.863V-8.686H76.575V-9.6h4.749v-1.8h.886v1.8h4.749v.911H82.21V-6.3h3.863Zm-.911-1.8V-5.389H78.346v2.682Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_3",
    "data-name": "\\u30D1\\u30B9 3",
    d: "M98.524-8.391H90.231v1.5A12.007,12.007,0,0,1,89.026-.91L88.14-1.5a10.791,10.791,0,0,0,1.181-2.707V-11.1h9.2Zm.295,7.185H90.231v-.886H94.07V-3.3H90.822v-.615H94.07V-4.8H90.822l-.295-.591H92c.295-.615.886-.91,1.181-1.5H90.822V-7.8h7.7v.91H94.07c-.295.3-.591.886-1.181,1.5a13.485,13.485,0,0,1,3.568-.32c-.3-.3-.886-.59-1.181-.886l.59-.3A10.194,10.194,0,0,1,98.819-4.8l-.886.3c0-.3-.295-.3-.886-.591H94.956v1.181h3.272V-3.3H94.956v1.206h3.863ZM97.638-9.3v-1.181H90.231V-9.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4",
    "data-name": "\\u30D1\\u30B9 4",
    d: "M105.95-6.3a15.837,15.837,0,0,1-1.79,3A11.729,11.729,0,0,1,101.21-.91l-.59-.886a13.144,13.144,0,0,0,3.24-2.411,9.062,9.062,0,0,0,1.5-3.593h-4.45v-.886h4.45v-2.707h.89v2.707H111V-7.8h-4.75a10.146,10.146,0,0,0,1.77,3.593A9.537,9.537,0,0,0,111.29-1.8l-.88.886C108.32-2.411,106.55-4.208,105.95-6.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5",
    "data-name": "\\u30D1\\u30B9 5",
    d: "M118.41-2.411c0,.615,0,.91-.3,1.206h-2.66l-.29-.591h1.47a1.093,1.093,0,0,0,.89-.3V-4.208h-4.75v-.886h4.75v-.615h.59a6.717,6.717,0,0,0,1.8-1.181h-5.37V-7.5h6.84v.615a27.7,27.7,0,0,1-2.97,1.8h4.74v.886h-4.74Zm4.45-4.478h-.89v-1.5h-8.02v1.5h-.88V-9.3h6.54a7.385,7.385,0,0,0,1.18-2.092h.89A4.758,4.758,0,0,1,120.5-9.3h2.36ZM116.04-9.6l-.88.3a6.907,6.907,0,0,0-1.21-1.8l.91-.3C115.16-10.8,115.75-10.187,116.04-9.6Zm2.37-.3-.6.3c-.29-.59-.59-1.205-.88-1.8l.59-.3C117.81-11.1,118.11-10.482,118.41-9.892Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_6",
    "data-name": "\\u30D1\\u30B9 6",
    d: "M132.65-6.89a6,6,0,0,1-2.06,2.682A14.165,14.165,0,0,0,135.33-1.8l-.59.886A21.888,21.888,0,0,1,130-3.592,25.837,25.837,0,0,1,125.25-.91l-.59-.886a14.651,14.651,0,0,0,4.74-2.411,6.892,6.892,0,0,1-2.38-2.682c-.3.591-.89.886-1.48,1.5L124.95-6a13.5,13.5,0,0,0,2.95-3l.89.615a4.144,4.144,0,0,1-1.18.886,10.814,10.814,0,0,0,2.39,3,6.743,6.743,0,0,0,2.06-3c-.29-.3-.59-.591-.88-.886l.88-.615a23.674,23.674,0,0,0,2.98,3l-.59.615C133.83-6,133.24-6.3,132.65-6.89Zm2.39-2.116H124.66v-.886h4.74v-1.5h.89v1.5h4.75Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7",
    "data-name": "\\u30D1\\u30B9 7",
    d: "M139.49-5.094a1.146,1.146,0,0,0-.29-.615h-1.5V-6.3a.292.292,0,0,0-.3.3l-.59-.591a6.816,6.816,0,0,0,2.39-1.5c-.91.3-1.5.3-2.39.591l-.29-.591c.29,0,.88-.3,1.18-.3,0,0,.29-.3.59-.615-.59-.3-1.18-.886-1.77-.886l.59-.59a.923.923,0,0,1,.59.3c.29-.615.59-.91.88-1.5l.62.3a5.9,5.9,0,0,1-1.21,1.5l.89.3a3.632,3.632,0,0,0,.91-1.205l.59.32a12.749,12.749,0,0,1-1.8,2.091,1.854,1.854,0,0,0,1.21-.3,1.146,1.146,0,0,0,.29-.615l.3.615A4.585,4.585,0,0,1,137.99-6.3h3.57V-6.89h.89V-6.3h4.15v.59h-1.77a1.146,1.146,0,0,0-.29.615h2.95V-4.5H136.52v-.591ZM146.01-.91h-.88v-.3H139.2v.3h-.91v-3.3h7.72ZM145.13-3v-.59H139.2V-3Zm0,1.206v-.615H139.2V-1.8ZM143.04-7.5a8.231,8.231,0,0,1-2.96.615l-.29-.615h.88v-3.888h2.96v2.707h-2.37V-7.5a3.255,3.255,0,0,1,1.48-.3c0-.3-.29-.3-.29-.591h.59a4.457,4.457,0,0,1,.91,1.206l-.62.3C143.33-7.185,143.33-7.185,143.04-7.5Zm-2.96,1.8c.3,0,.3.32.3.615h2.95c.3-.3.3-.615.62-.615Zm2.96-4.478V-10.8h-1.78v.615Zm0,1.181V-9.6h-1.78v.591Zm4.15.91c0,.3-.29.591-.59.911-.29,0-.59.3-1.18.3l-.29-.91c.88,0,1.18,0,1.18-.3a1.623,1.623,0,0,0-.89-1.206,6.168,6.168,0,0,0,.89-1.5h-1.48v4.207h-.59v-4.8h2.95v.591c-.29.615-.88.91-1.18,1.5C146.9-9.006,147.19-8.686,147.19-8.1Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8",
    "data-name": "\\u30D1\\u30B9 8",
    d: "M153.42-3.912a45.248,45.248,0,0,1-4.13,2.707l-.62-.886a20.173,20.173,0,0,0,4.46-2.116h-4.14v-.886h4.43V-6h-1.48v-4.478h1.48c0-.32.32-.615.32-1.206l.89.3c0,.3-.3.591-.3.911h1.77V-6h-1.77v.91h4.75v.886h-4.16a15.288,15.288,0,0,0,4.46,2.116l-.6.886a26.674,26.674,0,0,1-4.45-2.707v3h-.91ZM151.35-7.5A5.125,5.125,0,0,1,149.29-6l-.62-.591c1.21-.59,1.8-1.206,2.39-1.5Zm0-1.8-.59.3a6.17,6.17,0,0,0-1.77-1.181l.59-.615A8.712,8.712,0,0,1,151.35-9.3Zm3.87.91V-9.6h-2.69v1.206Zm0,1.8V-7.8h-2.69v1.206Zm3.86,0L158.49-6a6.009,6.009,0,0,0-2.09-1.5l.59-.591A9.227,9.227,0,0,1,159.08-6.595Zm-.3-3.888c-.61.59-.91,1.181-1.5,1.476l-.88-.3a9.448,9.448,0,0,0,1.77-1.8Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    "data-name": "\\u30D1\\u30B9 9",
    d: "M170.64-.91h-.88V-1.5h-7.73V-.91h-.88V-11.1h9.49Zm-.88-1.5v-7.776h-7.73v7.776ZM169.17-7.8h-1.5v4.208c-.3.3-.59.3-1.18.3h-1.18l-.3-.615h1.18c.3,0,.59,0,.59-.3.3,0,.3-.3.3-.591v-3h-4.46v-.886h4.46V-9.892h.59v1.206h1.5ZM165.9-5.389l-.89.3a6.371,6.371,0,0,0-1.18-1.5l.59-.59C165.01-6.595,165.31-6,165.9-5.389Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M73.893-46.457,67.963-58.44h0v11.983H65.9V-61.122h2.657l5.93,11.688h0V-61.122h2.092v14.665Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11",
    "data-name": "\\u30D1\\u30B9 11",
    d: "M88.435-46.457,86.959-50.64H81.914l-1.181,4.183H78.642l4.749-14.665h2.387l5.044,14.665ZM84.572-59.031h0L82.5-52.141h4.158Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M100.62-53.346H97.638v-1.5h5.042v7.209a7.984,7.984,0,0,1-4.452,1.5c-4.749,0-6.225-3.912-6.225-8.095,0-3.888,1.181-7.185,5.635-7.185,2.982,0,5.042,1.181,5.042,4.183h-2.66c0-1.5-.611-3-2.382-3-2.978,0-3.273,3.912-3.273,6,0,3,.591,6.889,4.159,6.889a3.192,3.192,0,0,0,2.1-.91Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13",
    "data-name": "\\u30D1\\u30B9 13",
    d: "M105.36-53.937c0-3.593,1.48-7.48,5.93-7.48s5.64,3.592,5.64,7.48-1.18,7.8-5.64,7.8S105.36-50.049,105.36-53.937Zm9.18,0c0-2.092-.29-6.3-3.25-6.3-3.27,0-3.27,4.207-3.27,6.3,0,2.387,0,6.594,3.27,6.594C114.25-47.343,114.54-51.55,114.54-53.937Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M122.27-46.457v-6.889l-4.46-7.776h2.69l3.25,5.684,3.56-5.684h2.09l-4.74,7.776v6.889Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M138.29-46.457l-1.48-4.183h-5.04l-1.48,4.183H128.2l5.04-14.665h2.39l5.04,14.665Zm-3.84-12.574h0l-2.39,6.89h4.46Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M73.6-41.954h2.092v9.6c0,3.592-.91,5.388-4.749,5.388-3.863,0-5.044-1.8-5.044-5.388v-9.6h2.362v9.6c0,2.091,0,4.183,2.682,4.183,2.362,0,2.657-2.092,2.657-4.183Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M86.959-26.969l-5.93-12.278h0v12.278H78.937V-41.954h2.682l5.93,11.688h0V-41.954h1.772v14.985Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M92.594-26.969h2.362V-41.954H92.594Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M102.09-26.969,97.047-41.954h2.658L103.57-29.97h0l3.86-11.984h2.07l-5.05,14.985Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M111.29-26.969V-41.954H119v1.5h-5.34v4.8h5.04v1.5h-5.04v5.685h5.63v1.5Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21",
    "data-name": "\\u30D1\\u30B9 21",
    d: "M128.79-26.969l-.59-4.207c-.59-1.477-1.18-2.387-3.25-2.387h-.91v6.594h-2.07V-41.954h2.98c2.95,0,5.93.591,5.93,3.888,0,2.116-1.48,3-3.27,3.593h0c2.09.319,2.39,1.82,2.98,3.617l.59,3.887Zm-3.84-8.095c2.07,0,3.54-.886,3.54-3,0-2.091-1.47-2.387-3.54-2.387h-.91v5.389Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_22",
    "data-name": "\\u30D1\\u30B9 22",
    d: "M133.54-29.675a9.475,9.475,0,0,0,4.16,1.206c1.5,0,2.68-.591,2.68-2.092,0-3.3-6.84-3.3-6.84-7.8,0-3,2.39-3.888,4.75-3.888a10.656,10.656,0,0,1,3.27.591v1.8a7.045,7.045,0,0,0-3.57-.886c-1.18,0-2.06.591-2.06,1.8,0,3.3,6.81,3,6.81,7.776,0,3.3-2.66,4.207-5.34,4.207a17.126,17.126,0,0,1-3.86-.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_23",
    "data-name": "\\u30D1\\u30B9 23",
    d: "M145.42-26.969h2.362V-41.954H145.42Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24",
    "data-name": "\\u30D1\\u30B9 24",
    d: "M153.74-26.969V-40.453h-3.57v-1.5h9.5v1.5H156.1v13.484Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25",
    "data-name": "\\u30D1\\u30B9 25",
    d: "M165.6-26.969v-6.889l-4.45-8.1h2.68l3.25,6,3.56-6h2.07l-4.75,8.1v6.889Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_26",
    "data-name": "\\u30D1\\u30B9 26",
    d: "M66.486-16.781a4.2,4.2,0,0,0,1.772.59c.886,0,1.476-.3,1.476-.886,0-1.8-3.543-1.5-3.543-3.912,0-1.181,1.181-1.8,2.362-1.8a3.5,3.5,0,0,1,1.772.319v.886a4.2,4.2,0,0,0-1.772-.59c-.59,0-1.181.3-1.181.886,0,1.5,3.248,1.5,3.248,3.912a2.11,2.11,0,0,1-2.362,2.091c-.591,0-1.477-.3-1.772-.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_27",
    "data-name": "\\u30D1\\u30B9 27",
    d: "M73.3-15.576v-3.3l-2.067-3.593h1.181l1.772,2.683,1.5-2.683H76.87l-2.387,3.593v3.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28",
    "data-name": "\\u30D1\\u30B9 28",
    d: "M83.686-15.576v-6h0l-2.067,6h-.886l-2.091-6h0v6h-.886v-6.89h1.476l1.8,5.685h.295L83.1-22.466h1.477v6.89Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29",
    "data-name": "\\u30D1\\u30B9 29",
    d: "M86.368-15.576v-6.89h1.476c1.477,0,2.683,0,2.683,1.8s-1.206,2.091-2.683,2.091h-.295v3Zm1.476-3.617c.886,0,1.477-.3,1.477-1.476,0-1.206-.591-1.206-1.477-1.206h-.295v2.682Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_30",
    "data-name": "\\u30D1\\u30B9 30",
    d: "M95.276-15.576v-3.3H92.889v3.3H91.708v-6.89h1.181v2.978h2.387v-2.978h1.181v6.89Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_31",
    "data-name": "\\u30D1\\u30B9 31",
    d: "M97.638-19.193c0-1.8.59-3.592,2.982-3.592,2.06,0,2.65,1.8,2.65,3.592,0,2.116-.59,3.912-2.65,3.912C98.228-15.281,97.638-17.077,97.638-19.193Zm4.452,0c0-.886-.29-2.977-1.47-2.977-1.506,0-1.8,2.091-1.8,2.977,0,1.206.295,3.3,1.8,3.3C101.8-15.9,102.09-17.987,102.09-19.193Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_32",
    "data-name": "\\u30D1\\u30B9 32",
    d: "M108.32-15.576l-2.66-5.708h0v5.708h-1.21v-6.89h1.5l2.66,5.389h0v-5.389h.89v6.89Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_33",
    "data-name": "\\u30D1\\u30B9 33",
    d: "M112.77-15.576v-3.3l-2.36-3.593h1.47l1.48,2.683,1.8-2.683h.88l-2.09,3.593v3.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_34",
    "data-name": "\\u30D1\\u30B9 34",
    d: "M119.29-19.193c0-1.8.62-3.592,2.68-3.592s2.69,1.8,2.69,3.592c0,2.116-.62,3.912-2.69,3.912S119.29-17.077,119.29-19.193Zm4.16,0c0-.886,0-2.977-1.48-2.977s-1.47,2.091-1.47,2.977c0,1.206,0,3.3,1.47,3.3S123.45-17.987,123.45-19.193Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_35",
    "data-name": "\\u30D1\\u30B9 35",
    d: "M129.4-15.576l-.32-1.8c-.29-.91-.59-1.206-1.47-1.206h-.3v3h-1.18v-6.89h1.48c1.18,0,2.68,0,2.68,1.8a1.4,1.4,0,0,1-1.5,1.476h0c1.21.32,1.21.911,1.5,1.821l.3,1.8Zm-1.79-3.912c.88,0,1.47-.3,1.47-1.181,0-1.206-.59-1.206-1.47-1.206h-.3v2.387Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_36",
    "data-name": "\\u30D1\\u30B9 36",
    d: "M136.52-15.9a5.12,5.12,0,0,1-2.07.615c-2.09,0-2.98-2.091-2.98-3.912,0-1.8.89-3.592,2.98-3.592a2.114,2.114,0,0,1,2.36,2.116h-1.48c0-.615-.29-1.5-1.18-1.5-1.2,0-1.5,1.8-1.5,2.682,0,1.5.3,3.3,2.09,3.3a4.233,4.233,0,0,0,1.78-.59Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_37",
    "data-name": "\\u30D1\\u30B9 37",
    d: "M141.56-15.576v-3.3h-2.68v3.3h-.89v-6.89h.89v2.978h2.68v-2.978h1.18v6.89Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_38",
    "data-name": "\\u30D1\\u30B9 38",
    d: "M144.24-15.576v-6.89h3.84v.591h-2.66v2.387h2.37v.615h-2.37v2.682h2.66v.615Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_39",
    "data-name": "\\u30D1\\u30B9 39",
    d: "M149.29-16.781a5.446,5.446,0,0,0,2.06.59c.59,0,1.18-.3,1.18-.886,0-1.8-3.24-1.5-3.24-3.912,0-1.181,1.18-1.8,2.36-1.8a2.522,2.522,0,0,1,1.48.319v.886a3.211,3.211,0,0,0-1.78-.59.942.942,0,0,0-.88.886c0,1.5,3.27,1.5,3.27,3.912,0,1.476-1.21,2.091-2.68,2.091-.3,0-1.18-.3-1.77-.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_40",
    "data-name": "\\u30D1\\u30B9 40",
    d: "M156.1-15.576v-6.3h-1.77v-.591h4.45v.591h-1.5v6.3Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_41",
    "data-name": "\\u30D1\\u30B9 41",
    d: "M163.53-15.576l-.61-1.8c0-.91-.3-1.206-1.18-1.206h-.59v3h-1.18v-6.89h1.77c1.18,0,2.68,0,2.68,1.8a1.4,1.4,0,0,1-1.5,1.476h0a1.665,1.665,0,0,1,1.2,1.821l.59,1.8Zm-1.79-3.912c.88,0,1.47-.3,1.47-1.181,0-1.206-.59-1.206-1.47-1.206h-.59v2.387Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_42",
    "data-name": "\\u30D1\\u30B9 42",
    d: "M170.05-15.576l-.59-2.116h-2.38l-.59,2.116h-1.18l2.36-6.89h1.2l2.37,6.89Zm-1.77-6h0l-.91,3.3h1.8Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_43",
    "data-name": "\\u30D1\\u30B9 43",
    d: "M57.874-47.638h0V-61.417H43.332v28.445a13.957,13.957,0,0,1-3.568.615,16.441,16.441,0,0,1-3.863-.615V-61.417H21.358v33.858L14.247-40.453V-61.417H-.3V-.3H14.247V-34.154L21.358-21.58V-.3H35.9v-29.38a17.169,17.169,0,0,0,3.863.3,14.587,14.587,0,0,0,3.568-.3V-.3H57.874V-47.638Zm-46.6,2.092L3.863-58.44H11.27Zm0,42.249H2.682V-54.232L11.27-39.567ZM32.948-58.44v24.286a14.719,14.719,0,0,1-8.317-13.484h0v-10.8ZM24.631-16.191,31.767-3.3H24.631ZM32.948-7.5,24.631-22.17V-37.451a20.749,20.749,0,0,0,8.317,6.89ZM46.284-58.44H54.9v10.8a14.938,14.938,0,0,1-8.613,13.484ZM54.9-3.3H46.284V-30.561a19.78,19.78,0,0,0,8.613-6.89Z",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.a4ef1023a7baf6d45834cf5df7742ec7.svg";
export { ForwardRef as ReactComponent };